import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f9a9f4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pickupDetail" }
const _hoisted_2 = { class: "Business_hours" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Business hours:", -1))
const _hoisted_4 = { class: "Business_hours bg_gray google_map_box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Contact information:", -1))
const _hoisted_6 = { class: "google_map_box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "google_map_icon",
  src: "http://image.kilimall.com/kenya/new_wap/logistics/phone_black_24@2x.png",
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "Business_hours" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Service provider:", -1))
const _hoisted_13 = { class: "Business_hours bg_gray" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Address: ", -1))
const _hoisted_15 = { class: "google_map_box" }
const _hoisted_16 = { class: "google_map_box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { title: "Pickup Station Details" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString($setup.networkInfo.businessTime), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _hoisted_5,
        _createElementVNode("p", null, _toDisplayString($setup.networkInfo.firstName?$setup.networkInfo.firstName:'') + " " + _toDisplayString($setup.networkInfo.lastName?$setup.networkInfo.lastName:'') + " " + _toDisplayString($setup.networkInfo.mobileNo), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("a", {
          href: `tel:${$setup.networkInfo.mobileNo}`
        }, _hoisted_10, 8, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("p", null, _toDisplayString($setup.networkInfo.stationName), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", null, _toDisplayString($setup.networkInfo.stationDesc), 1),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goMapFn && $setup.goMapFn(...args))),
            class: "google_map_icon",
            src: "http://image.kilimall.com/kenya/new_wap/logistics/icon_all_address_nor@2x.png",
            alt: ""
          })
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imgs, (item, i) => {
        return (_openBlock(), _createElementBlock("img", {
          key: i,
          src: item.fileUrl,
          alt: ""
        }, null, 8, _hoisted_18))
      }), 128))
    ])
  ]))
}